// ──────────────────────────────────────────────
// Tipos de actividad CRM — fuente única de verdad
// ──────────────────────────────────────────────
// Vocabulario central de los tipos de actividad (`crm_actividades.tipo`) y su
// presentación visual: `text` (texto del badge), `label` (tooltip) y `bg` (color).
//
// Hasta ahora el vocabulario vivía triplicado y sin fuente única:
//   - TIPO_CONFIG local en components/VentasMiListaClientesV2/components/ActividadesRecientes.js
//   - JSDoc de utils/saveCrmActividad.js
//   - query hardcodeado `tipo=in.(MAIL,MEET,CALL)` en utils/getCrmActividades.js
//
// Este archivo unifica el LADO VISUAL (lo consume ActividadesRecientes). La
// migración de saveCrmActividad y getCrmActividades al vocabulario central es
// deuda anotada y NO se aborda en este commit.

export const TIPOS_ACTIVIDAD = {
  MAIL: { text: "Mail", label: "Email", bg: "#0d6efd" },
  CALL: { text: "Call", label: "Llamada", bg: "#6f42c1" },
  MEET: { text: "Meet", label: "Reunión", bg: "#198754" },
  QUOTE: { text: "Quote", label: "Propuesta", bg: "#fd7e14" },
  // labelAgenda: override SOLO para el selector del modal de agenda ("Cierre").
  // El badge (text/label) sigue usando "Sale"/"Venta" — no cambiar esos.
  SALE: { text: "Sale", label: "Venta", bg: "#d4a017", labelAgenda: "Cierre" },
  RRSS: { text: "RRSS", label: "RRSS", bg: "#20c997" },
  "FOLLOW UP": { text: "F.Up", label: "Follow Up", bg: "#6c757d" },
};

// Tipo por defecto cuando un `tipo` no existe en el mapa. Espeja el fallback
// preexistente de ActividadesRecientes (`TIPO_CONFIG[tipo] || TIPO_CONFIG.MAIL`).
export const TIPO_ACTIVIDAD_DEFAULT = "MAIL";

// Subconjunto agendable manualmente desde el modal "Movimientos futuros".
// El orden es deliberado: es el orden en que se ofrecen en el selector del modal.
// Excluye MAIL y RRSS (no se agendan a mano). Consumido por el Commit 2.
export const TIPOS_ACTIVIDAD_AGENDABLES = ["RRSS", "CALL", "MEET", "FOLLOW UP", "QUOTE", "SALE"];
